/** Deterministic PRNG (same as the prototype) so every player sees the same shuffle for a round. */
export function seeded(n: number): () => number {
  let s = n * 9301 + 49297;
  return () => (s = (s * 9301 + 49297) % 233280) / 233280;
}

export function shuffle<T>(arr: readonly T[], seed: number): T[] {
  const r = seeded(seed);
  const a = arr.slice();
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(r() * (i + 1));
    [a[i], a[j]] = [a[j]!, a[i]!];
  }
  return a;
}

/** Seed for day d (0-based) round r (0-based), as in the prototype. */
export const roundSeed = (d: number, r: number): number => d * 13 + r * 7 + 1;
